/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Store_RemoveInputs */

const vi_shop_home_store_remove = /** @type {(inputs: Shop_Home_Store_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá cửa hàng`)
};

/**

* @param {Shop_Home_Store_RemoveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_store_remove = /** @type {((inputs?: Shop_Home_Store_RemoveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Store_RemoveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_store_remove(inputs)
});